import React, { useContext } from "react";
import { useHistory } from "react-router";
import { Formik } from "formik";
import * as Yup from "yup";
import firebase from "../../firebase";
import { SnackbarAlert } from "../SnackbarAlert";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = makeStyles((theme) => ({
  buttonRegister: {
    textTransform: "none",
    color: theme.palette.common.white,
    padding: 13,
    borderRadius: 8,
    fontSize: "1.2em",
    letterSpacing: 1,
  },
  doctorLink: {
    color: theme.palette.warning.main,
  },
  input: {
    margin: 5,
  },
}));

const RegisterForm = () => {
  const classes = useStyles();
  const history = useHistory();

  const createAccount = firebase.functions().httpsCallable("createUser");

  const { setSnackbarState } = useContext(SnackbarAlert);

  return (
    <Formik
      initialValues={{
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        createPassword: "",
        country: {
          name: "Philippines",
          code: "+63 ",
        },
        subsCheckbox: false,
      }}
      validationSchema={Yup.object().shape({
        firstName: Yup.string().required("Please input your first name"),
        lastName: Yup.string().required("Please input your last name"),
        email: Yup.string()
          .required("Please input your email")
          .email("Invalid format"),
        mobileNumber: Yup.number()
          .max(9999999999, "Invalid mobile number")
          .required("Please input your mobile number"),
        createPassword: Yup.string()
          .required("Please input your password")
          .min(6, "Password should have a minimum of 6 characters"),
        loginCheckbox: Yup.boolean(),
      })}
      onSubmit={async (values, actions) => {
        try {
          await createAccount({
            email: values.email,
            mobileNumber: values.country.code + values.mobileNumber,
            password: values.createPassword,
            firstName: values.firstName,
            lastName: values.lastName,
            fullName: values.firstName + " " + values.lastName,
            country: values.country.name,
            forDoctor: false,
          });
          actions.resetForm();
          setSnackbarState({
            state: true,
            message: "Account creation successful! 👍",
            status: "info",
          });
        } catch (error) {
          actions.resetForm();
          //console.log(error.code);
          //console.log(error.message);
          setSnackbarState({
            state: true,
            message: error.message,
            status: "error",
          });
        }
      }}
    >
      {(formik) => (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit(e);
          }}
          noValidate
        >
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <Box textAlign="left" fontWeight="fontWeightBold" fontSize={26}>
                Join LifeDoc
              </Box>
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={6}>
              <Box textAlign="right" fontSize={13} lineHeight={3}>
                Are you a doctor?&nbsp;
                <Link
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    history.push("/doctor_register");
                  }}
                  className={classes.doctorLink}
                >
                  Register Here
                </Link>
                .
              </Box>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="firstName"
                name="firstName"
                placeholder="First Name"
                margin="dense"
                variant="outlined"
                className={classes.input}
                {...formik.getFieldProps("firstName")}
                error={formik.errors.firstName && formik.touched.firstName}
                helperText={
                  formik.errors.firstName && formik.touched.firstName
                    ? formik.errors.firstName
                    : "First Name"
                }
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="lastName"
                name="lastName"
                placeholder="Last Name"
                margin="dense"
                variant="outlined"
                className={classes.input}
                {...formik.getFieldProps("lastName")}
                error={formik.errors.lastName && formik.touched.lastName}
                helperText={
                  formik.errors.lastName && formik.touched.lastName
                    ? formik.errors.lastName
                    : "Last Name"
                }
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="email"
                name="email"
                placeholder="Email ID"
                margin="dense"
                variant="outlined"
                className={classes.input}
                {...formik.getFieldProps("email")}
                error={formik.errors.email && formik.touched.email}
                helperText={
                  formik.errors.email && formik.touched.email
                    ? formik.errors.email
                    : "Email ID"
                }
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="country"
                name="country"
                placeholder="Country"
                margin="dense"
                variant="outlined"
                disabled
                className={classes.input}
                {...formik.getFieldProps("country.name")}
                helperText="Country"
                fullWidth
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="mobileNumber"
                name="mobileNumber"
                placeholder="Mobile Number"
                margin="dense"
                variant="outlined"
                className={classes.input}
                {...formik.getFieldProps("mobileNumber")}
                error={
                  formik.errors.mobileNumber && formik.touched.mobileNumber
                }
                helperText={
                  formik.errors.mobileNumber && formik.touched.mobileNumber
                    ? formik.errors.mobileNumber
                    : "Mobile Number"
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {formik.values.country.code}
                    </InputAdornment>
                  ),
                }}
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="createPassword"
                name="createPassword"
                placeholder="Create Password"
                margin="dense"
                variant="outlined"
                type="password"
                className={classes.input}
                {...formik.getFieldProps("createPassword")}
                error={
                  formik.errors.createPassword && formik.touched.createPassword
                }
                helperText={
                  formik.errors.createPassword && formik.touched.createPassword
                    ? formik.errors.createPassword
                    : "Create Password"
                }
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="subsCheckbox"
                    {...formik.getFieldProps("subsCheckbox")}
                    disabled={formik.isSubmitting}
                  />
                }
                label={
                  <Box textAlign="left" fontSize={13}>
                    Receive relevant offers and promotional communication from
                    Life Doctor
                  </Box>
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Box textAlign="left" fontSize={11}>
                By signing up. I agree to the&nbsp;
                <Link
                  href="https://life-doc.web.app/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="primary"
                >
                  terms
                </Link>
                .
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Button
                color="primary"
                variant="contained"
                className={classes.buttonRegister}
                disabled={formik.isSubmitting}
                type="submit"
                fullWidth
              >
                Register
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default RegisterForm;
